import {Injectable} from '@angular/core';
import {StorageInterface} from './storage.interface';

@Injectable()
export class LocalStorageService implements StorageInterface {
    get(id: string): any {
        const value = localStorage.getItem(id);

        return null === value ? null : JSON.parse(value);
    }

    set(id: string, value: any): void {
        localStorage.setItem(id, JSON.stringify(value));
    }

    remove(id: string): void {
        localStorage.removeItem(id);
    }
}



// WEBPACK FOOTER //
// ./src/shared/services/storage/main/local-storage.service.ts